import type { PopupMenuOverlayMode } from './popup-menu-overlay.tsx';

/**
 * Desktop popups are anchored popovers: an outside press closes them and still
 * reaches its target. Smaller screens show bottom sheets, which stay modal.
 */
export function getPopupMenuOverlayMode({
  isDesktop,
}: {
  isDesktop: boolean;
}): PopupMenuOverlayMode {
  return isDesktop ? 'click-through' : 'modal';
}
